import { render, staticRenderFns } from "./SalesOrderItems.vue?vue&type=template&id=1aaf5e1e"
import script from "./SalesOrderItems.vue?vue&type=script&lang=js"
export * from "./SalesOrderItems.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderItems.vue?vue&type=style&index=0&id=1aaf5e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports